


















import Vue from 'vue';

export default Vue.extend({
  name: 'Error',
  components: {
  },
  data() {
    return {
    }
  },
  methods: {
    onPushPath(path: string) {
      this.$router.push(path, () => {}); // eslint-disable-line
      this.$emit('pushPath', path);
    },
  }
})
